export const defaultImage = '/resort_header.jpg';
export const REVIEW_ANCHOR = 'write_review';
